import React, {useEffect} from 'react';
import './Button.scss'

const Button = (props) => {
    
    const { text, className, onClickHandle } = props


    useEffect( () => {

    }, [])


    return (
        <button className={`button ${className}`} onClick={ onClickHandle }>
            {text}
        </button>
    );
}
export default Button;